import { I18n } from "@assets/strings";
import React from "react";
import { useHistory } from "@core/routing/useHistory";
import styled, { css } from "styled-components";
import { Path } from "@core/routing/path";
import { CurrentProfile } from "@domain/currentProfile/currentProfile";
import { DetailedPerson } from "@domain/user/user";
import { useConnectUser } from "@utils/messaging/hooks";
import { theme } from "@ui/styles/theme";
import { mobile } from "@ui/styles/utils";
import { LoadingButton } from "@ui/components/buttons/loadingButton";
import { ContactIcon } from "@ui/components/icons";
import { row } from "@ui/components/layout";

interface ContactButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
	profile: DetailedPerson;
	currentProfile?: CurrentProfile | null;
	isBig?: boolean;
	iconMode?: boolean;
	onToggle?: () => void;
	isOrg?: boolean;
}
export const ContactButton: React.FC<ContactButtonProps> = ({
	profile,
	isOrg,
	isBig,
	iconMode,
	onToggle,
	currentProfile,
	...htmlProps
}) => {
	// const currentProfile = useCurrentProfile();
	const iconSize = iconMode ? 16 : 14;

	if (!currentProfile || !currentProfile.chatToken) {
		return null;
	}
	const history = useHistory();

	const connectUser = useConnectUser({
		profileId: currentProfile.id,
		userToken: currentProfile.chatToken.token,
		userId: profile.id,
	});

	return (
		// <Link to={Path.Chatmessage}>
		<StyledButton
			iconMode={iconMode}
			buttonType="primary"
			big={isBig}
			{...htmlProps}
			onClick={(e) => {
				e.preventDefault();
				e.stopPropagation();
				history.push(Path.Chatmessage(currentProfile.id, connectUser?.channel?.data?.id as string));
			}}
		>
			{(isBig || iconMode) && (
				<>
					<StyledContactIcon color={theme.colors.white} width={iconSize} height={iconSize} />
					<span>{I18n.t("profile.card.message")}</span>
				</>
			)}
		</StyledButton>
		// </Link>
	);
};

const StyledButton = styled(LoadingButton)<{ iconMode?: boolean; big?: boolean }>`
	${row(8, "center", "center")};
	min-width: 50px;
	border-radius: ${({ big }) => (big ? 7 : 4)}px;
	padding: ${({ big }) => (big ? "10px 28px" : "4px 13px")};
	min-height: ${({ big }) => (big ? 34 : 23)}px;
	margin-left: 10px;

	${({ iconMode }) =>
		iconMode &&
		css`
			display: inline-flex;
			align-items: center;
			justify-content: center; /* Centre l'icône et le texte sur mobile */
			border-radius: 26px;
			padding: 14px 13px;
		`}

	@media ${mobile} {
		span {
			display: none; /* Masquer le texte sur mobile */
		}
	}
`;

const StyledContactIcon = styled(ContactIcon)`
	@media ${mobile} {
		margin-right: 4px;
	}
`;
